import axios from 'axios';
import { apiAddress, vEGLD_TOKEN_ID } from 'config';

const getTokenBalance = async (
  address: string,
  tokenId: string
): Promise<string> => {
  const url = `${apiAddress}/accounts/${address}/tokens/${tokenId}`;
  const response = await axios.get(url);
  if (response.status < 300) {
    return response.data.balance;
  }
  return '0';
};

export const getVEGLDBalance = async (address: string) =>
  await getTokenBalance(address, vEGLD_TOKEN_ID);
